import Mention from '@tiptap/extension-mention';
import { createMentionDropdown } from './mention_dropdown';

// Fetches the allowed users for the current context, filtered by the typed query. A
// fresh request fires on every keystroke after "@", exactly as the search is meant to
// work — the list is small (a company's staff), so no debounce is needed.
function fetchCandidates(mentionUrl, query) {
  const separator = mentionUrl.includes('?') ? '&' : '?';
  const endpoint = `${mentionUrl}${separator}q=${encodeURIComponent(query || '')}`;

  return fetch(endpoint, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
    .then((response) => (response.ok ? response.json() : []))
    .catch(() => []);
}

// The Tiptap mention node. It serializes to a real span carrying data-id/data-label,
// so the server can parse the mentioned users from the saved HTML (Mentionable concern).
// The allowed list is context-specific and provided per mount via `mentionUrl`.
export function buildMentions(mentionUrl) {
  return Mention.configure({
    HTMLAttributes: { class: 'mention' },
    renderLabel: ({ node }) => `@${node.attrs.label ?? node.attrs.id}`,
    suggestion: {
      char: '@',
      items: ({ query }) => fetchCandidates(mentionUrl, query),
      render: createMentionDropdown
    }
  });
}
